const validationErrors = err => {
  if (!err || !err.response || !err.response.data) {
    return {}
  } else if (!err.response.data.errors) {
    return {}
  }

  return err.response.data.errors
}

export {
  validationErrors,
}
